import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from '../i18n';

function PrivacyPage() {
  const { t, toggleLocale, isPortuguese } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Nav */}
      <nav className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-2 text-gray-600 dark:text-gray-300 hover:text-green-600"
          >
            <ArrowLeft className="w-5 h-5" />
            <img src="/logo.png" alt="KeepNota" className="h-8 w-auto" />
            <span className="font-bold text-xl text-gray-900 dark:text-white">KeepNota</span>
          </Link>

          <button
            onClick={toggleLocale}
            className="px-3 py-1 rounded-full bg-gray-100 dark:bg-gray-700 text-sm font-medium hover:bg-gray-200 dark:hover:bg-gray-600 transition"
          >
            {t.flag} {t.lang.split('-')[0].toUpperCase()}
          </button>
        </div>
      </nav>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
          {t.privacy.title}
        </h1>
        <p className="text-gray-500 dark:text-gray-400 mb-8">
          {t.privacy.lastUpdate}
        </p>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm p-8">
          <p className="text-gray-600 dark:text-gray-300 mb-8 text-lg">
            {t.privacy.intro}
          </p>

          <div className="space-y-8">
            {t.privacy.sections.map((section, i) => (
              <div key={i}>
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                  {section.title}
                </h2>
                <div className="text-gray-600 dark:text-gray-300 whitespace-pre-line">
                  {section.content.split('**').map((part, j) =>
                    j % 2 === 1 ? (
                      <strong key={j} className="font-semibold text-gray-900 dark:text-white">
                        {part}
                      </strong>
                    ) : (
                      part
                    )
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Back link */}
        <div className="mt-8 text-center">
          <Link
            to="/"
            className="text-green-600 hover:text-green-700 font-medium"
          >
            ← {isPortuguese ? 'Voltar para pagina inicial' : 'Back to homepage'}
          </Link>
        </div>
      </main>
    </div>
  );
}

export default PrivacyPage;
